import type { SprayCalibration } from '../services/sprayService';

/**
 * Build a fresh `SprayCalibration` shape from a saved one, suitable for
 * pre-filling the calibration modal in Add mode.
 *
 * - Strips `_id` so the modal recognises it as a new (Add-mode) record.
 * - Strips `attachmentKey` — a fresh signed PDF belongs to the new event.
 * - Strips `signedOffBy` — the new calibration is a separate sign-off.
 * - Strips `editHistory` — clone starts a new audit chain.
 * - Forces `status: 'active'` so cloning a soft-deleted row produces an
 *   active calibration.
 * - Sets `date` to today's ISO date (YYYY-MM-DD) so the form shows the
 *   current day rather than the source's date.
 * - Preserves intensity levels exactly, including any override values.
 *
 * Pure / framework-agnostic / unit-tested. Track Phase 4.
 */
export function cloneCalibration(source: SprayCalibration): SprayCalibration {
  const today = new Date().toISOString().slice(0, 10);
  return {
    date: today,
    performedBy: source.performedBy,
    treeSpacing: source.treeSpacing,
    treesPerHectare: source.treesPerHectare,
    status: 'active',
    intensityLevels: source.intensityLevels.map(lvl => ({ ...lvl })),
  };
}
